import _get from 'lodash/get';
import { featuresState } from 'features/selectors';

export const reportState = state => _get(featuresState(state), 'reports');

// Inventory Feed

export const inventoryAtsState = state => _get(reportState(state), 'inventoryAtsReport');
export const inventoryAtsReports = state => _get(inventoryAtsState(state), 'inventoryAts');
export const getInventoryAtsFeedData = state => _get(inventoryAtsReports(state), 'data');
export const getInventoryAtsReport = state => _get(getInventoryAtsFeedData(state), 'inventory');
export const getInventoryTotalRecords = state => 
  _get(getInventoryAtsFeedData(state), 'totalRecords');
export const getInventoryAtsPage = state => _get(getInventoryAtsFeedData(state), 'page');
export const getInventoryAtsItemsPerPage = state => 
  _get(getInventoryAtsFeedData(state), 'itemsPerPage');
export const getLastPage = state => _get(inventoryAtsReports(state), 'lastPage');
export const getFilters = state => _get(inventoryAtsReports(state), 'filters');

export const getShowOptionsModal = state => _get(inventoryAtsReports(state), 'showOptionsModal');
export const getIsRefreshing = state => _get(inventoryAtsReports(state), 'isRefreshing');
export const getIsExporting = state => _get(inventoryAtsReports(state), 'isExporting');
export const getIsFetchingFeed = state => _get(inventoryAtsReports(state), 'isFetchingFeed');
export const selectIncludeSpecialZones = state => 
  _get(inventoryAtsReports(state), 'includeSpecialZones', false);
export const selectShipTypes = state => _get(inventoryAtsReports(state), 'shipTypes');


// settings
const settingsState = state => _get(inventoryAtsState(state), 'settings');
export const getSettingsColumnsOrder = state => _get(settingsState(state), 'columnsOrder');
export const getSettingsColumns = state => _get(settingsState(state), 'columns');
export const getSettingsItemsPerPage = state => _get(settingsState(state), 'itemsPerPage');
export const getSettingsSorting = state => _get(settingsState(state), 'sorting');


// Config
export const configState = state => _get(inventoryAtsState(state), 'config');
export const selectFilterOptions = state => _get(configState(state), 'filterOptions');
export const selectColumnFilterOptions = state => _get(configState(state), 'columnFilterOptions');
export const selectQuickFilterOptions = state => _get(configState(state), 'quickFilterOptions');

